import React from 'react';
import './ErrorMessage.less';
import {DrawerPopup} from "dialog-layout/drawer-popup/DrawerPopup.tsx";
import ErrorIcon from 'new-images/error.svg';
import {Message} from 'compositions/message/Message';

export const VIPPS_ERROR_MESSAGE_POPUP = 'VIPPS_ERROR_MESSAGE_POPUP';
export const DISCOUNT_ERROR_MESSAGE_POPUP = 'DISCOUNT_ERROR_MESSAGE_POPUP';
export const RESTAURANT_CLOSED_ERROR_MESSAGE_POPUP = 'RESTAURANT_CLOSED_ERROR_MESSAGE_POPUP';
export const MODIFIERS_VALIDATION_ERROR_MESSAGE_POPUP = 'MODIFIERS_VALIDATION_ERROR_MESSAGE_POPUP';
export const SEND_ORDER_ERROR_MESSAGE_POPUP = 'SEND_ORDER_ERROR_MESSAGE_POPUP';
export const REPEAT_ORDER_ERROR_MESSAGE_POPUP = 'REPEAT_ORDER_ERROR_MESSAGE_POPUP';
export const MOBILE_PAY_ORDER_CANCELLED_ERROR_MESSAGE_POPUP = 'MOBILE_PAY_ORDER_CANCELLED_ERROR_MESSAGE_POPUP';
export const MOBILE_PAY_RETURN_NO_STATE_ERROR_MESSAGE_POPUP = 'MOBILE_PAY_RETURN_NO_STATE_ERROR_MESSAGE_POPUP';
export const MOBILE_PAY_RETURN_NO_URL_ERROR_MESSAGE_POPUP = 'MOBILE_PAY_RETURN_NO_URL_ERROR_MESSAGE_POPUP';
export const MOBILE_PAY_INIT_ERROR_MESSAGE_POPUP = 'MOBILE_PAY_INIT_ERROR_MESSAGE_POPUP';
export const ADYEN_CARD_PAYMENT_ERROR_MESSAGE_POPUP = 'ADYEN_CARD_PAYMENT_ERROR_MESSAGE_POPUP';
export const SWISH_PAYMENT_ERROR_MESSAGE_POPUP = 'SWISH_PAYMENT_ERROR_MESSAGE_POPUP';
export const GOOGLE_PAY_PAYMENT_ERROR_MESSAGE_POPUP = 'GOOGLE_PAY_PAYMENT_ERROR_MESSAGE_POPUP';
export const APPLE_PAY_PAYMENT_ERROR_MESSAGE_POPUP = 'APPLE_PAY_PAYMENT_ERROR_MESSAGE_POPUP';


export const ErrorMessage = ({title, description, description2, control, onOverlayClick}) => {
	return <DrawerPopup
		onOverlayClick={onOverlayClick}
	>
		<div className="error-message">
			<div className="error-message__message">
				<Message
					icon={ErrorIcon}
					title={title}
					description={description}
					description2={description2}
				/>
			</div>
			{
				control && <div className="error-message__control">
					{control}
				</div>
			}
		</div>

	</DrawerPopup>
}
